<template>
  <ui-modal v-model="isVisible">
    <ui-modal-header
      title="Edit wallet name"
      @dismiss="isVisible = false"
    />
    <div class="p-3">
      <ui-input-group label="Name">
        <ui-input v-model="walletName" />
      </ui-input-group>
      <p class="text-sm text-gray-600 dark:text-gray-400">
        Only you can see the name you set.
      </p>
    </div>
    <ui-modal-footer>
      <ui-button
        :is-loading="isLoading"
        @click="save"
      >
        Save
      </ui-button>
    </ui-modal-footer>
  </ui-modal>
</template>

<script>
import {
  computed,
  defineComponent,
  inject,
  toRefs,
  ref,
} from "vue";
import { useMutation } from "@vue/apollo-composable";
import editWalletNameMutation from "@/graphql/wallet/mutations/editWalletName.mutation.gql";
import walletByAddressQuery from "@/graphql/wallet/queries/walletByAddress.query.gql";
import { useUiDialog } from "@/components/ui-dialog/useUiDialog";

import UiButton from "../ui/UiButton.vue";
import UiInput from "../ui/UiInput.vue";
import UiInputGroup from "../ui/UiInputGroup.vue";
import UiModal from "../ui/UiModal.vue";
import UiModalFooter from "../ui/UiModalFooter.vue";
import UiModalHeader from "../ui/UiModalHeader.vue";
import {mapGetters} from 'vuex';

export default defineComponent({
  components: {
    UiInput,
    UiInputGroup,
    UiModal,
    UiModalHeader,
    UiModalFooter,
    UiButton,
  },

  props: ["wallet"],

  setup(props) {
    const { wallet } = toRefs(props);
    const newName = ref("");
    const { info } = useUiDialog();

    const walletName = computed({
      get() {
        return wallet.value?.displayName;
      },
      set(value) {
        newName.value = value;
      }
    });

    const requireLogin = inject("requireLogin");

    const {
      mutate: editWalletName,
    } = useMutation(
      editWalletNameMutation,
      () => ({
        variables: {
          walletId: wallet.value?.id,
          name: newName.value,
        },
        refetchQueries: [
          {
            query: walletByAddressQuery,
            variables: { address: wallet.value?.id }
          }
        ]
      })
    );

    return {
      requireLogin,
      newName,
      walletName,
      editWalletName,
      info,
    }
  },

  data() {
    return {
      isVisible: false,
      isLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "auth/isLoggedIn",
    }),
  },
  methods: {
    async show() {
      if (!this.isLoggedIn) {
        await this.requireLogin();
      }
      this.isVisible = true;
      this.newName = '';
    },
    save() {
      this.isLoading = true;
      return this.editWalletName()
        .then(() => {
          this.info("Wallet name updated");
          this.isVisible = false;
        }).finally(() => {
          this.isLoading = false;
        });
    }
  },
});
</script>

<style>
</style>